import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'

// import files
import Featurescards from '../Components/Featurescards'

// imports images
import ImgforSection from '../img/initialdistribution.png';
import ImgforSection1 from '../img/Group714.png';
import ImgforSection2 from '../img/Layer2.png';
import ImgforSection3 from '../img/lock.png';
import ImgforSection4 from '../img/layer1.png';
import ImgforSection5 from '../img/Antiwhale.png';
import cat from '../img/134.png';
import './home.css'



const Features = () => {
  return (
    <div className="pcc---feature-section" id="Feature" style={{borderBottom:'1px solid black'}}>
        <Container maxWidth="lg">
        

            <Grid
                container
                justify="center"
                xs={12}
                spacing={3}
                className="mx-auto py-5 my-5"
            >
              <Grid
                  container
                  justify="center"
                  direction="column"
                  xs={12}
                  spacing={3}
                  className="mx-auto"
              >
              <h2 className="pcc---section-main-heading mb-3 my-5">FEATURES<br /></h2>
              </Grid>
                {/* <Featurescards 
                  title="Farming" 
                  discription="Farm your LP tokens WETH/PussyCatCore LP and  USDT/PussyCatCore LP. APY from 100% to 400%." 
                  number="1" 
                /> */}
                
                <Featurescards
                  img={ImgforSection3}
                  title="Liquidity Generating" 
                  discription="All pCAT v3 LP tokens are locked." 
                  number="1" 
                />
                <Featurescards 
                  img={ImgforSection1}
                  title="Crypto Rewards" 
                  discription="A portion of the selling tax is returned to holders as BNB token rewards." 
                  number="2" 
                />
                <Featurescards 
                  img={ImgforSection2}
                  title="Max Token Supply" 
                  discription="Our ecosystem has a total limit of
                  10,000,000,000 tokens. This value
                  cannot be exceeded by any means .This
                  ensures that the supply never goes up
                  by further minting." 
                  number="3"                 />
                <Featurescards 
                  img={ImgforSection4}
                  title="Appealing Tokenomics" 
                  discription="We're launching with a 10% selling tax. 1% of all sales go back to holders as pCATv3 tokens, another 4.5% goes into liquidity while an extra 2.25% is distributed as BNB rewards every 7 days. 2.25% more goes into the maintenance wallet." 
                  number="4"                 />
                {/* <Featurescards 
                  title="Reputed Profits Source" 
                  discription="Our currency earns profits by secure and reliable pools and vaults. The system keeps upto date with the latest and best investment strategies to supplement the profit-generating protocol." 
                  number="6"                 /> */}
                <Featurescards 
                  img={ImgforSection}
                  title="Initial Distribution" 
                  discription="A presale buying limit ensures a fair
                  chance of any one getting to be a part
                  of our movement." 
                  number="5"                 />
                {/* <Featurescards 
                  title="Non-inflationary" 
                  discription="Benefits are always wielded by holders. When selling, a sales transfer fee is returned to the farming pools. This ensures that buying is always more incentivized than selling." 
                  number="6"                 /> */}
                <Featurescards 
                  img={ImgforSection5}
                  title="Anti Whale" 
                  discription="Benefits are always wielded by holders.
                  A selling tax ensures buying pressure is
                  always higher than selling pressure" 
                  number="6"                 />
                {/* <Featurescards 
                  title="Blocked Uniswap Withdrawls" 
                  discription="Blocking uni-swap withdrawals ensures a more stable market economy providing extra protection to those within the ecosystem" 
                  number="7"                 /> */}
            </Grid>
        </Container>
    </div> 
  );
}

export default Features;
